module.exports = __webpack_public_path__ + "img/sdk5.adc42383.png";